<div class="flex h-full flex-col px-3 py-2">
  <h2 class="shrink-0 text-sm font-semibold text-slate-700 mb-2">Próximos y vencidos</h2>
  <div class="flex-1 min-h-0 grid grid-cols-2 gap-4 overflow-hidden">
    <!-- Próximos -->
    <div class="flex flex-col min-h-0">
      <h3 class="shrink-0 text-xs font-semibold text-emerald-700 mb-1.5 uppercase tracking-wide">
        Próximos (30 d.)
      </h3>
      @if ((data()?.upcomingCharges?.length ?? 0) === 0) {
        <p class="text-slate-400 text-xs">Sin cargos próximos.</p>
      } @else {
        <ul class="flex-1 min-h-0 overflow-y-auto space-y-1.5">
          @for (charge of data()?.upcomingCharges?.slice(0, 10); track trackCharge($index, charge)) {
            <li class="flex justify-between items-center gap-2 text-xs border-b border-slate-100 pb-1.5 last:border-0">
              <a [routerLink]="['/invoices', charge.invoiceId]"
                 class="text-slate-700 hover:text-emerald-600 font-medium truncate min-w-0">
                {{ charge.invoice?.number ?? ('#' + charge.invoiceId) }}
              </a>
              <span class="font-semibold text-slate-900 shrink-0 tabular-nums">
                {{ formatCurrency(charge.total ?? 0) }}
              </span>
            </li>
          }
        </ul>
        <a routerLink="/invoices" class="shrink-0 mt-1 text-xs font-medium text-emerald-600 hover:underline">
          Ver todas →
        </a>
      }
    </div>
    <!-- Vencidos -->
    <div class="flex flex-col min-h-0">
      <h3 class="shrink-0 text-xs font-semibold text-red-600 mb-1.5 uppercase tracking-wide">
        Vencidos
      </h3>
      @if ((data()?.overdueCharges?.length ?? 0) === 0) {
        <p class="text-slate-400 text-xs">Sin vencidos.</p>
      } @else {
        <ul class="flex-1 min-h-0 overflow-y-auto space-y-1.5">
          @for (charge of data()?.overdueCharges?.slice(0, 10); track trackCharge($index, charge)) {
            <li class="flex justify-between items-center gap-2 text-xs border-b border-slate-100 pb-1.5 last:border-0">
              <a [routerLink]="['/invoices', charge.invoiceId]"
                 class="text-slate-700 hover:text-red-600 font-medium truncate min-w-0">
                {{ charge.invoice?.number ?? ('#' + charge.invoiceId) }}
              </a>
              <span class="font-semibold text-red-600 shrink-0 tabular-nums">
                {{ formatCurrency(charge.total ?? 0) }}
              </span>
            </li>
          }
        </ul>
        <a routerLink="/invoices" class="shrink-0 mt-1 text-xs font-medium text-red-500 hover:underline">
          Ver todas →
        </a>
      }
    </div>
  </div>
</div>
